/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Hero_OverlineInputs */

const en_st_hero_overline = /** @type {(inputs: St_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio`)
};

const id_st_hero_overline = /** @type {(inputs: St_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep Studio`)
};

/**
* | output |
* | --- |
* | "Bystep Studio" |
*
* @param {St_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_hero_overline = /** @type {((inputs?: St_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_hero_overline(inputs)
	return en_st_hero_overline(inputs)
});